import fetchApi from "../fetchApi";

export const validateSourceCard = async ({
  office_id,
  processor_reference,
}) => {
  const options = {
    method: "POST",
    headers: new Headers({
      "Content-Type": "application/json",
    }),
    redirect: "follow",
    body: JSON.stringify({
      office_id: office_id,
      processor_reference: processor_reference,
    }),
  };

  return await fetchApi(
    `card-issuing/sell-order/validate-source-card`,
    options
  );
};
